import { render } from "./Control.vue?vue&type=template&id=c6a8f4d4&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"

import "./Control.vue?vue&type=style&index=0&id=c6a8f4d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c6a8f4d4"

export default script